import useTitle from "@/components/hooks/useTitle";
import BodyContent from "@/components/landing-page/BodyContent";
import Footer from "@/components/landing-page/Footer";
import Header from "@/components/landing-page/Header";
import Main from "@/components/landing-page/Main";
import Section from "@/components/landing-page/Section";
import React from "react";
const About = () => {
  return (
    <React.Fragment>
      <div className="mx-auto max-w-[820px] pb-[110px] pt-[56px] max-sm:pb-[76px] max-sm:pt-10">
        <p className="text-center font-inter text-[12px] font-semibold uppercase tracking-[0.18em] text-[#8CFF8C] max-sm:text-start">
          Our story
        </p>
        <h1 className="mt-4 text-center font-geoGraph text-[36px] font-medium leading-tight text-[#EDEDED] max-sm:text-start max-sm:text-[30px]">
          Why are we doing Blockset
        </h1>
        <div className="mx-auto mt-10 max-w-[720px] font-inter text-[16px] font-medium leading-[1.9] text-[#b7b7b7] antialiased max-sm:text-[15px]">
          <p>
            We started building Blockset after running into the same issue at
            our previous employer. Most of our data lived in an operational OLTP
            database, while the analytics team needed a reliable way to explore
            it without depending on engineers or fragile replicas.
          </p>
          <p className="mt-7">
            The setup worked until it did not. Our engineering team was small,
            the infrastructure was naive, and there was never enough time to
            build the kind of data platform that made querying fast, stable, and
            low-friction for everyone else.
          </p>
          <p className="mt-7">
            Blockset is our answer for teams in that same early-stage position:
            teams that need useful analytics without standing up complex
            pipelines, managing extra infrastructure, or carrying avoidable
            downtime.
          </p>
        </div>
        <div className="mx-auto mt-12 max-w-[720px] border-t border-t-[rgba(255,255,255,.12)] pt-8 font-inter text-[16px] font-medium leading-[1.8] text-[#ededed] antialiased max-sm:text-[15px]">
          <p>
            To see how Blockset can fit into your data workflow, book a demo
            and we will walk through the product with your use case in mind.
          </p>
          <div className="mt-8 flex justify-center">
            <a
              href="https://cal.com/blockset/30min?month=2024-08&date=2024-08-23"
              aria-label="blockset-schedule-demo"
              target="__blank"
              className="inline-flex rounded-[7px] bg-[#ededed] px-4 py-2 font-inter text-[13px] font-semibold text-black-6 transition-[background-color,box-shadow,transform] duration-200 ease-out hover:-translate-y-0.5 hover:bg-white hover:shadow-md active:translate-y-0 active:scale-[0.98]"
            >
              Schedule a Demo
            </a>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
const about = () => {
  useTitle("About");
  return (
    <Main>
      <Header showHero={false}>
        <BodyContent>
          <Section>
            <div className=" max-sm:overflow-x-hidden">
              <About />
            </div>
          </Section>
        </BodyContent>
      </Header>
      <Footer />
    </Main>
  );
};

export default about;
